// extracted by mini-css-extract-plugin
export var phone = "_2p-0";
export var phoneDragging = "_2p-1";